export default __webpack_public_path__ + "static/media/ico-verifier.1d425d32.svg";